
import React from 'react';
import { ShoppingCart, Award, Shield, TrendingUp } from 'lucide-react';
import { publicFeatures } from '../../config/publicFeatures';

export function BuyingGuide({ product, category }) {
  const getBuyingTips = () => {
    // Generic buying tips that work for most products
    const tips = [
      {
        icon: TrendingUp,
        title: "Best Time to Buy",
        content: publicFeatures.priceAlerts
          ? "Monitor price history and set alerts for significant drops. Prices often fluctuate during sales events like Black Friday, Prime Day, and end-of-month clearances."
          : "Prices often fluctuate during sales events like Black Friday, Prime Day, and end-of-month clearances, so check the current price on Amazon before you buy."
      },
      {
        icon: Shield,
        title: "Warranty & Returns",
        content: "Check Amazon's return policy and manufacturer warranty. Most electronics come with at least 1-year warranty. Consider extended protection for high-value items."
      },
      {
        icon: Award,
        title: "What to Look For",
        content: "Read recent reviews, check seller ratings, and verify product authenticity. Look for Amazon's Choice or high-rated products with substantial review counts."
      },
      {
        icon: ShoppingCart,
        title: "Purchase Tips",
        content: publicFeatures.priceAlerts
          ? "Compare prices across different sellers, check for bundle deals, and consider Prime shipping benefits. Add items to your cart to monitor for price changes."
          : "Compare prices across different sellers, check for bundle deals, and consider Prime shipping benefits."
      }
    ];

    return tips;
  };

  const tips = getBuyingTips();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 mb-6">
        <ShoppingCart className="w-5 h-5 text-green-600 dark:text-green-400" />
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          Smart Buying Guide
        </h3>
      </div>

      <div className="grid gap-4">
        {tips.map((tip, index) => (
          <div 
            key={index}
            className="flex gap-4 p-4 bg-gray-50 dark:bg-slate-700 rounded-lg"
          >
            <div className="w-10 h-10 bg-white dark:bg-slate-600 rounded-full flex items-center justify-center flex-shrink-0">
              <tip.icon size={18} className="text-gray-600 dark:text-gray-400" />
            </div>
            <div className="flex-1">
              <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-2">
                {tip.title}
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                {tip.content}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-4">
        <h4 className="font-medium text-blue-900 dark:text-blue-200 mb-2">
          💡 Pro Tip
        </h4>
        <p className="text-sm text-blue-800 dark:text-blue-300">
          {publicFeatures.priceAlerts
            ? 'Set up price alerts for multiple similar products to compare deals and find the best value. '
            : 'Compare several similar products to find the best value. '}
          Prices can vary significantly between different models and sellers.
        </p>
      </div>
    </div>
  );
}
